import React from 'react';

import { useSelector } from 'react-redux';

import './styles.scss';
import { ConversationsStatisticsChart } from 'components';
import ReportsHeader from '../ReportsHeader';
import ConversationsReportBadge from './ConversationsReportBadge';
import AccessOverlay from 'components/AccessOverlay';
import useTranslation from 'hooks/useTranslation';
import DashboardMainSectionWrapper from 'layouts/Dashboard/DashboardMainSectionWrapper';

// ?
// chats types

//     null: text
//     0: image
//     1: video
//     2: audio
//     3: compress
//     4: file

// ?

const ALLOWED_TYPES = [2, 3, 7, 8, 10, 11]; // آزمایشی + تجاری + پریمیوم + پریمیوم پلاس + وی آی پی

const mapState = ({ conversationsData, userData }) => ({
  conversationsCount: conversationsData.conversationsCount,
  conversations: conversationsData.conversations,
  agentStartedConversationsCount:
    conversationsData.agentStartedConversationsCount,
  profile: userData.profile,
  conversationsData,
});

const ConversationsReport = (props) => {
  const {
    conversationsCount,
    conversations,
    agentStartedConversationsCount,
    profile,
  } = useSelector(mapState);

  const { getTranslation } = useTranslation('STATISTICS');
  const { t } = getTranslation();

  const allConversations = conversationsCount
    ? conversationsCount.all.conversations
    : '...';
  const allClosedConversations = conversationsCount
    ? conversationsCount.all.closed
    : '...';
  // const allClosedAgentConversations = conversationsCount
  //   ? conversationsCount.all.closedAgent
  //   : '...';
  // const allDeniedConversations = conversationsCount
  //   ? conversationsCount.all.denied
  //   : '...';
  const lastWeekConversations = conversationsCount
    ? conversationsCount.lastWeek.count
    : '...';

  // const hasAccessToFeature = ALLOWED_TYPES.includes(+profile?.accountType);

  return (
    <>
      <AccessOverlay allowedTypes={ALLOWED_TYPES} />

      <ReportsHeader
        title={t('CONVS_STATS_HEADER_TITLE')}
        description={t('CONVS_STATS_HEADER_DESCRIPTION')}
      />

      <DashboardMainSectionWrapper>
        <main className='conversations-report'>
          <h2 className='h2'>{t('CONVS_STATS_OVERALL_STATISTICS_TITLE')}</h2>
          <div className='box'>
            <ConversationsReportBadge
              amount={allConversations}
              isIncreased={true}
              title={t('CONVS_REPORT_BADGE_all_CONVS_TITLE')}
              description={`${lastWeekConversations} ${t(
                'CONVS_REPORT_BADGE_all_CONVS_DESC'
              )}`}
              hasHelpIcon
            />
            <ConversationsReportBadge
              amount={allClosedConversations}
              isIncreased={false}
              title={t('CONVS_REPORT_BADGE_ENDED_TITLE')}
              // description={`به زودی ...`}
              // unit='دقيقه'
            />
            <ConversationsReportBadge
              amount={agentStartedConversationsCount}
              isIncreased={false}
              title={t('CONVS_REPORT_BADGE_STARTED_TITLE')}
              // description={`به زودی ...`}
              // unit='دقيقه'
            />
          </div>
          <h2 className='h1-statistics'>
            {t('CONVS_STATS_CHART_SECTION_TITLE')}
          </h2>
          <ConversationsStatisticsChart
            conversations={conversations}
            isFreePackage={profile.accountType === 0 ? true : false}
          />
        </main>

        {/* temporarily disabled */}
        {/* {hasAccessToFeature && <Messages />} */}
      </DashboardMainSectionWrapper>
    </>
  );
};

export default React.memo(ConversationsReport);
